import { init } from "@sentry/react";

const Sentry = () =>
  init({
    dsn: window._env_.SENTRY_DSN,
    environment: window._env_.SENTRY_ENVIROMENT,
    tracesSampleRate: 1.0,
    beforeSend(event) {
      event.breadcrumbs = event.breadcrumbs?.filter((B) => B.level === "error");
      return event;
    },
  });

export default Sentry;
